import { CurrencyPipe, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ClrLoadingModule } from '@clr/angular';
import { JobPositionControlling } from '../../../../_shared/interfaces';
import { IAlertType, JobsStoreService, AlertService } from '../../../../_shared/services';

@Component({
  selector: 'app-job-details-controlling',
  standalone: true,
  imports: [NgIf, NgFor, CurrencyPipe, ClrLoadingModule],
  templateUrl: './job-details-controlling.component.html',
  styleUrl: './job-details-controlling.component.sass'
})
export class JobDetailsControllingComponent implements OnChanges {
  @Input() projectId: string = '';
  @Input() jobId: number = 0;

  loading = false;
  rows: JobPositionControlling[] = [];

  get sumOfferTotal(): number {
    return this.rows.reduce((acc, row) => acc + (row.offer_total || 0), 0);
  }

  get sumEkTotal(): number {
    return this.rows.reduce((acc, row) => acc + (row.ek_total || 0), 0);
  }

  get sumVkTotal(): number {
    return this.rows.reduce((acc, row) => acc + (row.vk_total || 0), 0);
  }

  get sumMarginTotal(): number {
    return this.rows.reduce((acc, row) => acc + (row.margin_total || 0), 0);
  }

  constructor(
    private jobsStore: JobsStoreService,
    private alertDispatcher: AlertService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['projectId'] || changes['jobId']) &&
      this.projectId &&
      this.jobId > 0
    ) {
      this.loadControlling();
    }
  }

  private loadControlling(): void {
    this.loading = true;
    this.jobsStore.getJobPositionControlling(this.projectId, this.jobId).subscribe({
      next: (response) => {
        this.rows = response?.object ?? [];
      },
      error: () => {
        this.rows = [];
        this.alertDispatcher.show(
          {
            message: 'Controlling-Daten konnten nicht geladen werden.',
            clrAlertType: IAlertType.WARNING
          },
          3000
        );
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}
